{
  "title": "autobrr",
  "username": "Username",
  "password": "Password",
  "confirmPassword": "Confirm password",
  "createAccount": "Create account",
  "rememberMe": "Remember me",
  "forgotPassword": "Forgot password?",
  "forgotPasswordHelp": "Reset via terminal:",
  "signIn": "Sign in",
  "continueWith": "Or continue with",
  "openidConnect": "OpenID Connect",
  "errors": {
    "required": "Required",
    "usernameRequired": "Username is required",
    "passwordRequired": "Password is required",
    "passwordsDoNotMatch": "Passwords don't match!",
    "generic": "An error occurred!",
    "oidcFailed": "OIDC authentication failed"
  }
}
